import { render } from "./TrainingDocumentMaintain.vue?vue&type=template&id=5ab5656c"
import script from "./TrainingDocumentMaintain.vue?vue&type=script&lang=ts"
export * from "./TrainingDocumentMaintain.vue?vue&type=script&lang=ts"
script.render = render

export default script